<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('supplier.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('supplier.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              v-tooltip="$t('supplier.search')"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.vendor_code }}</td>
          <td>{{ record.vendor_name }}</td>
          <td>{{ record.contact_person }}</td>
          <td>
            <p class="ts-mb-0">{{ record.contact_number1 }}</p>
            <p class="ts-mb-0">{{ record.contact_number2 }}</p>
          </td>
          <td>{{ record.contact_email }}</td>
          <td>{{ record.credit_day }}</td>
          <td>{{ record.credit_amount }}</td>
          <td>
            <span class="badge badge-success" v-if="record.is_local">Yes</span>
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="text-center ts-space-x-3">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('supplier.pageTitle')"
        centered
        width="550px"
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'departmentIndex',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('supplier/profile', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.supplier.profile.search
      },
      set (newValue) {
        this.$store.commit('supplier/profile/SET_SEARCH', newValue)
        this.$store.commit('supplier/profile/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        { name: this.$t('supplier.code') },
        { name: this.$t('supplier.name') },
        { name: this.$t('supplier.contactPerson') },
        { name: this.$t('supplier.contact') },
        { name: this.$t('supplier.email') },
        { name: this.$t('supplier.creditDay') },
        { name: this.$t('supplier.creditAmount') },
        { name: this.$t('supplier.isLocal') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('supplier/profile/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.showForm = true
    },
    edit (record) {
      this.$store.commit('supplier/profile/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit () {
      this.$store.commit('supplier/profile/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    deleteRecord (record) {
      record._deleting = true
      this.$store
        .dispatch('supplier/profile/destroy', record.vendor_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('supplier/profile/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
